// extracted by mini-css-extract-plugin
export var attachment = "_m4-a";
export var emailContainer = "_m4-4";
export var emailContentPaddedContainer = "_m4-b";
export var emailHeader = "_m4-6";
export var emailIframe = "_m4-3";
export var emailInfoIcon = "_m4-9";
export var emailShortenedSummary = "_m4-e";
export var infoDropdown = "_m4-0";
export var infoRowBoundedContent = "_m4-d";
export var internal = "_m4-5";
export var merchant = "_m4-8";
export var messageInputContainer = "_m4-h";
export var normal = "_m4-7";
export var replyCard = "_m4-f";
export var subtleButton = "_m4-1";
export var subtleButtonIconContainer = "_m4-2";
export var toggleViewRepliesButton = "_m4-c";
export var wrappingText = "_m4-g";